<!--
무자료 등록(재고방식) > 라벨출력 안내 > 보관장소 수정
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <div class="uk-text-large3 uk-text-center">
                    보관장소 직접작성
                </div>
            </div>

            <div class="uk-modal-body">

                <app-input-text
                    v-model="inputStorage"
                    placeholder=""
                    input-size="large"
                ></app-input-text>

            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-button-large uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary uk-button-large"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 등록된 상품정보 배열
             */
            prods: {
                type: Array,
            },
        },
        data: function () {
            return {
                // 입력 - 보관장소
                inputStorage: this.box.storage,
            };
        },
        computed: {
            /**
             * 상품ID 배열
             * @return array [id, id ...]
             */
            prodIds() {
                return _.map(this.prods, 'id');
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {
                this.inputStorage = this.box.storage;
                this.displayForm();
            },

            /**
             * submit
             */
            submit() {
                // promise 생성
                let p = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/regions/' + this.regionId + '/nodata-stocks/storage-batch',
                        data: {
                            '_token': this.csrfToken,
                            'prod_ids': JSON.stringify(this.prodIds),

                            storage:  this.inputStorage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.box.storage = this.inputStorage;
                    _.each(this.prods, (prod) => {
                        prod.storage = this.inputStorage;
                    });

                    UIkit.modal(this.$el).hide();
                }).catch(() => {
                    // 오류인경우
                });
            },


        },


    }
</script>
